window.addEventListener('DOMContentLoaded', () => {
    let hasSwatches = document?.querySelector('.related-swatches');
    if (hasSwatches) {
        let mainProductMedia = document?.querySelector('.product-media.product-media--image');
        let mainProductDescription = mainProductMedia?.querySelector('img')?.alt?.split(' - PartyLite US')[0];
        let swatchCoincidence = hasSwatches.querySelector(`[title="${mainProductDescription}"]`);
        if (swatchCoincidence !== null) {
            swatchCoincidence.classList.add('swatch-mark');
        }
    }
})